import { Component } from '@angular/core';

@Component({
  selector: 'app-documentation',
  templateUrl: './documentation.component.html',
  styleUrl: './documentation.component.scss'
})
export class DocumentationComponent {
  scrollToSection(event: MouseEvent, sectionId: string): void {
    event.preventDefault();

    document.getElementById(sectionId)?.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
    history.replaceState(null, '', `#${sectionId}`);
  }

}
